import React from 'react';

import { Stepper as BaseStepper } from 'components/uikit/Stepper/Stepper';

import { useStepperPresenter } from './Stepper.presenter';

export const Stepper = () => {
  const presenter = useStepperPresenter();

  return <BaseStepper steps={presenter.steps} />;
};
